(function Module() {
	'use strict';

	module.exports = {
		date: 10,
		digits: 100,
		email: 254,
		groupAlias: 100,
		float: 50,
		invitationKey: 5,
		middleInitial: 1,
		money: 50,
		monthYear: 7,
		password: 50,
		percent: 100,
		personName: 100,
		phone: 13,
		phoneWithExtension: 100,
		string: 99999,
		ssn: 11,
		taxId: 10,
		url: 254,
		postCode: 10,
		facilityId: 7,
		image: 250
	};
})();
